import {
  useState,
  useRef,
  useEffect,
  useCallback,
  RefObject,
}                     from 'react';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

export type TElementSize = Breakpoint | null;
type TUseMeasureData     = [TElementSize, RefObject<HTMLDivElement>];

export const useMeasure = (eventName = 'resize', element = window): TUseMeasureData => {
  const [elementSize, setElementSize] = useState<TElementSize>(null);
  const elementRef = useRef<HTMLDivElement>(null);

  const letsMeasure = useCallback(
    (): void => {
      const { width } = elementRef?.current?.getBoundingClientRect() ?? { width: 0 };
      let size: TElementSize = 'xl';

      if (width < 480) {
        size = 'xs';
      } else if (width < 760) {
        size = 'sm';
      } else if (width < 1024) {
        size = 'md';
      } else if (width < 1680) {
        size = 'lg';
      }

      setElementSize(size);
    }, [setElementSize],
  );

  useEffect(() => {
    letsMeasure();

    element.addEventListener(eventName, letsMeasure);

    return (): void => {
      element.removeEventListener(eventName, letsMeasure);
    };
  }, [eventName, element, letsMeasure]);

  return [elementSize, elementRef];
};
